// extracted by mini-css-extract-plugin
export default {"iconContainer":"NavIcon_iconContainer__nLF2R","icon":"NavIcon_icon__MDEMj"};